import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageUI } from "components/pages/LoginPage";
import { getDefaultModalData, getDefaultModalUI } from "components/custom-ui/CustomModal/components/FirstTimeLoginModal";

/**
 * @name Capture002TokenVerificationCodeEntered
 * @returns {React.Component}
 * @description A capture component in the capture group "Tokens - Transactions".
 */
export default function Capture002TokenVerificationCodeEntered(props) {
    const modalUI = getDefaultModalUI();
    const modalData = getDefaultModalData();

    const _modalData = BCMSStateManagerCRUD.init({ data: modalData, ui: modalUI })
        .update(["ui", "step"], 2)
        .update(["data", "passcode"], "123456")
        .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update(["modal", "id"], "FirstTimeLoginModal")
        .update(["modal", "data"], _modalData)
        .submit();

    return <LoginPage ui={ui} />
}